import Component from 'Component';
import Lang from 'lang.js';
const messages = require('../lang');

export default class Language extends Component {

  _FALLBACK_LOCALE = 'en';

  initialize() {

    this.translator = new Lang({
      messages: messages,
      locale:   this.documentLanguage,
      fallback: this._FALLBACK_LOCALE
    });

    this.logger(`Used locale: ${this.getLocale()}`);

    return super.initialize();
  }

  get documentLanguage() {
    return document.querySelector('html').getAttribute('lang') || 'en';
  }

  getLocale() {
    return this.translator.getLocale();
  }

  get(key) {
    return this.translator.get(key);
  }

  choice() {
    return this.translator.choice(...arguments);
  }

  has(key) {
    return this.translator.has(key);
  }

}